const MEMBERSHIP_ACK_REQUIRED_PREFIX = 'docupet:membership-ack-required';

const membershipAckRequiredKey = (orderId, itemId) => `${MEMBERSHIP_ACK_REQUIRED_PREFIX}:${orderId}:${itemId}`;

const membershipAckStorage = () => {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch (e) {
    // Do not simplify to a direct property read: blocked-cookie Safari throws here.
    return null;
  }
};

export const MembershipAckMixins = {
  methods: {
    // Stores a requirement marker only, never the checkbox's checked state: persisting
    // the tick would re-mount the box pre-checked and skip the acknowledgement.
    setMembershipAckRequired(orderId, itemId) {
      const storage = membershipAckStorage();
      if (!storage || !orderId || !itemId) return;
      try {
        storage.setItem(membershipAckRequiredKey(orderId, itemId), 'true');
      } catch (e) {
        /* storage unavailable */
      }
    },
    isMembershipAckRequired(orderId, itemId) {
      const storage = membershipAckStorage();
      if (!storage || !orderId || !itemId) return false;
      try {
        return storage.getItem(membershipAckRequiredKey(orderId, itemId)) === 'true';
      } catch (e) {
        return false;
      }
    },
    removeMembershipAckRequired(orderId, itemId) {
      const storage = membershipAckStorage();
      if (!storage) return;
      try {
        storage.removeItem(membershipAckRequiredKey(orderId, itemId));
      } catch (e) {
        /* nothing to clean up */
      }
    },
    removeAllMembershipAckRequired(orderId) {
      const storage = membershipAckStorage();
      if (!storage) return;
      try {
        const prefix = orderId ? `${MEMBERSHIP_ACK_REQUIRED_PREFIX}:${orderId}:` : `${MEMBERSHIP_ACK_REQUIRED_PREFIX}:`;
        Object.keys(storage)
          .filter((key) => key.startsWith(prefix))
          .forEach((key) => storage.removeItem(key));
      } catch (e) {
        /* nothing to clean up */
      }
    },
  },
};
